import calendar from "@dhl-official/icons/calendar.svg";
// eslint-disable-next-line import/no-cycle
import { Icon } from "root/libs/ui-components/src";
import { DhlInputField } from "@dhl-official/react-library";
import styled, { css } from "styled-components";
import { isBrowser } from "../utils/deviceUtils";

export const displaySmallDay = isBrowser
  ? window.matchMedia("(max-width: 400px)").matches
  : false;
export const DAY_WIDTH = `${displaySmallDay ? "36" : "44"}px`;
export const DAY_MARGIN = "4px";

/**
 * This will be used to layout anything in 7 columns
 * Eg: Calendar's Title, Weeks and Days use this layout
 */
export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: calc(7 * ${DAY_WIDTH});
`;

export const Container = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
`;

export const Abbr = styled.abbr`
  border: none !important;
  text-decoration: none;
`;

export const StyledIcon = styled(Icon).attrs({
  "aria-hidden": true,
  role: "presentation",
  icon: calendar,
})`
  color: var(--dui-color-black-500);
  fill: var(--dui-color-black-500);
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  align-items: center;
  width: var(--dui-size-font-md);
  height: var(--dui-size-font-md);
`;
export const CalendarTable = styled.table`
  border-spacing: var(--dui-size-space-0);
  color: var(--dui-color-black-500);
  font-size: var(--dui-size-font-md);
  line-height: var(--dui-size-space-10x);
  text-align: center;
  width: var(--dui-size-space-full);
  border-collapse: collapse;
`;

export const CalendarRow = styled.tr`
  font-size: var(--dui-size-font-sm);
  font-weight: 700;
  line-height: ${DAY_WIDTH};
  text-align: center;
  text-transform: uppercase;
`;

export const CalendarHead = styled.thead`
  color: var(--dui-color-gray-600);
  font-weight: 200;
  font-size: var(--dui-size-font-xs);
  line-height: var(--dui-size-space-10x);
  text-decoration: none;
  text-transform: uppercase;
  height: var(--dui-size-space-24x);
  padding: var(--dui-size-space-0);
  width: var(--dui-size-space-24x);

  & abbr {
    border-bottom: 0 !important;
  }
`;

export const CalendarBody = styled.tbody`
  color: rgba(0, 0, 0, 0.9);
`;

export const CalendarCell = styled.td`
  height: var(--dui-size-space-24x);
  padding: var(--dui-size-space-0);
  width: var(--dui-size-space-24x);
`;

export const DateToggle = styled.button`
  appearance: none;
  align-items: center;
  appearance: none;
  background: var(--dui-color-white-500);
  border: var(--dui-size-space-0);
  border-radius: var(--dui-size-radius-0);
  border-bottom-right-radius: var(--dui-size-radius-md);
  border-top-right-radius: var(--dui-size-radius-md);
  box-shadow: none;
  color: var(--dui-color-black-500);
  cursor: pointer;
  display: flex;
  height: calc(var(--dui-size-space-24x) + var(--dui-size-space-1x)) !important;
  justify-content: center;
  padding: var(--dui-size-space-7x);
  position: absolute;
  right: var(--dui-size-space-1x);
  top: var(--dui-size-space-1x);
  user-select: none;

  &:focus {
    outline: 0;
  }
`;

export const IconWrapper = styled.i.attrs({
  role: "presentation",
  "aria-hidden": true,
})`
  display: "inline-flex";
  box-sizing: content-box;
  justify-content: center;
  align-items: center;
  ${({ rotate }) =>
    rotate &&
    css`
      transform: rotate(${rotate});
    `}

  height: var(--dui-size-space-10x);
  width: var(--dui-size-space-10x);

  & svg {
    flex: 1;
  }

  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}
`;

const isOpenStyle = (isOpen, trueValue, falseValue = "inherit") =>
  isOpen ? `${trueValue} !important` : falseValue;

export const DatePickerInputField = styled(DhlInputField)`
  & > div > input {
    height: calc(
      var(--dui-size-space-24x) + var(--dui-size-space-3x)
    ) !important;
    border-color: ${({ isOpen }) =>
      isOpenStyle(isOpen, "var(--dui-color-black-500)")};
    box-shadow: ${({ isOpen }) =>
      isOpenStyle(
        isOpen,
        "var(--dui-size-space-0) var(--dui-size-space-0) var(--dui-size-space-0) var(--dui-size-space-1) var(--dui-color-black-500)",
        "none"
      )};
    &:focus,
    &:active {
      border-color: var(--dui-color-black-500);
    }
  }
`;
